window.Alpine.data('readMore', readMore);

/**
 * Alpine.js component for the read-more functionality
 * Provides smooth height transitions when expanding/collapsing content
 */
export default function readMore() {
	return {
		readMore: false,
		contentOverflows: false,
		originalHeight: 0,
		expandedHeight: 0,

		/**
		 * Initialize the component
		 */
		init() {
			// Initial check after component is mounted
			this.$nextTick(() => {
				this.checkOverflow();
			});

			// Set up resize handling with Alpine-native cleanup
			const resizeHandler = () => this.checkOverflow();
			window.addEventListener('resize', resizeHandler);

			// Cleanup event listener using Alpine's destroy event
			this.$el.addEventListener('alpine:destroy', () => {
				window.removeEventListener('resize', resizeHandler);
			});
		},

		/**
		 * Check if content overflows and store height measurements
		 */
		checkOverflow() {
			const content = this.$refs.content;
			if (!content) return;

			this.contentOverflows = content.scrollHeight > content.clientHeight;

			if (this.contentOverflows) {
				// Store the original clamped height
				this.originalHeight = content.clientHeight;

				// Temporarily remove line clamp to measure full height
				this.expandedHeight = content.scrollHeight;
			}
		},

		/**
		 * Toggle between expanded and collapsed states with animation
		 * @param {string} transitionDuration - CSS duration value (e.g., '300ms')
		 */
		toggleReadMore(transitionDuration) {
			this.readMore = !this.readMore;
			const content = this.$refs.content;

			if (this.readMore) {
				// Expanding
				content.style.height = `${this.originalHeight}px`;
				content.style.overflow = 'hidden';

				// Force a reflow
				void content.offsetWidth;

				content.style.transition = `height ${transitionDuration} ease`;
				content.style.height = `${this.expandedHeight}px`;

				// After transition completes
				setTimeout(() => {
					content.style.height = '';
					content.style.overflow = '';
				}, parseInt(transitionDuration));
			} else {
				// Collapsing
				content.style.height = `${this.expandedHeight}px`;
				content.style.overflow = 'hidden';

				// Force a reflow
				void content.offsetWidth;

				content.style.transition = `height ${transitionDuration} ease`;
				content.style.height = `${this.originalHeight}px`;

				// After transition completes
				setTimeout(() => {
					content.style.height = '';
					content.style.overflow = '';
				}, parseInt(transitionDuration));
			}
		},
	};
}
